import { useState } from "react";
import PropTypes from "prop-types";
import "./ContactSection.css";

function ContactSection({ copy }) {
  const [status, setStatus] = useState({ state: "idle", message: "" });

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (status.state === "loading") return;

    const form = event.currentTarget;
    const formData = new FormData(form);
    formData.append("_subject", "New inquiry from xcelerateit.com");

    try {
      setStatus({ state: "loading", message: "" });
      const response = await fetch(copy.submissionEndpoint, {
        method: "POST",
        headers: { Accept: "application/json" },
        body: formData
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      form.reset();
      setStatus({ state: "success", message: copy.successMessage });
    } catch (error) {
      console.error("Form submission error", error);
      setStatus({ state: "error", message: copy.errorMessage });
    }
  };

  return (
    <section className="contact" id="contact" data-reveal>
      <div className="contact__inner">
        <div className="contact__intro">
          <span className="contact__eyebrow">Let&apos;s collaborate</span>
          <h2 className="contact__title">{copy.headline}</h2>
          <p className="contact__description">{copy.description}</p>
          <div className="contact__details">
            <div>
              <span className="contact__label">Email</span>
              <a href="mailto:xcelerateit@outlook.com" className="contact__value">
                xcelerateit@outlook.com
              </a>
            </div>
          </div>
        </div>
        <form className="contact__form" onSubmit={handleSubmit} data-reveal data-reveal-delay="120">
          <div className="form-row">
            <label className="form-label" htmlFor="name">
              Name *
            </label>
            <input className="form-input" id="name" name="name" type="text" required />
          </div>
          <div className="form-row">
            <label className="form-label" htmlFor="email">
              Work email *
            </label>
            <input className="form-input" id="email" name="email" type="email" required />
          </div>
          <div className="form-row form-row--split">
            <div>
              <label className="form-label" htmlFor="company">
                Company *
              </label>
              <input className="form-input" id="company" name="company" type="text" required />
            </div>
            <div>
              <label className="form-label" htmlFor="timeline">
                Desired timeline
              </label>
              <select className="form-input" id="timeline" name="timeline" defaultValue="">
                <option value="" disabled>
                  Select one
                </option>
                <option value="0-30">0-30 days</option>
                <option value="30-90">30-90 days</option>
                <option value="90-plus">90+ days</option>
                <option value="unsure">Exploratory</option>
              </select>
            </div>
          </div>
          <div className="form-row">
            <label className="form-label" htmlFor="message">
              What challenge can we help you tackle? *
            </label>
            <textarea
              className="form-input form-input--textarea"
              id="message"
              name="message"
              rows="5"
              required
            />
          </div>
          <button className="form-submit" type="submit" disabled={status.state === "loading"}>
            {status.state === "loading" ? "Sending..." : "Send message"}
          </button>
          {status.state !== "idle" && (
            <p
              className={`form-status ${
                status.state === "success" ? "form-status--success" : "form-status--error"
              }`}
            >
              {status.message}
            </p>
          )}
        </form>
      </div>
    </section>
  );
}

ContactSection.propTypes = {
  copy: PropTypes.shape({
    headline: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    successMessage: PropTypes.string.isRequired,
    errorMessage: PropTypes.string.isRequired,
    submissionEndpoint: PropTypes.string.isRequired
  }).isRequired
};

export default ContactSection;
